<template>
  <div class="demo-grid" id="loginPage">  
    <XR-head titleText="登陆" :rightShow="false" ref="head"></XR-head>
    <img  :src='siteConfig.MobileBgImage' class="loginbg" />
    <div class="login-form">
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33">
          <mu-text-field label="用户名/手机号" icon=":fa fa-phone" labelFloat fullWidth v-model="username" />
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33">
          <mu-text-field label="密码" type="password" helpText="请输入密码" icon=":fa fa-lock" labelFloat fullWidth v-model="password" />
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33" class="login-div">
          <mu-checkbox label="记住账号" class="demo-checkbox" v-model="isRemember" />
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33" class="login-div">
          <mu-raised-button label="登  陆" class="demo-raised-button" primary fullWidth @click="Login()" />
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33" class="div2">
          <!--<mu-flat-button label="手机注册" class="demo-flat-button"/>-->   
          <router-link to="/register"><mu-flat-button label="账号注册" class="demo-flat-button left"/></router-link>
          <router-link to="/findpassword"><mu-flat-button label="找回密码" class="demo-flat-button right"/></router-link>
        </mu-col>
      </mu-row>
      <mu-row gutter>
        <mu-col width="100" tablet="50" desktop="33" class="div3">
          <XR-toast ref="XRtoast"></XR-toast>
        </mu-col>
      </mu-row>
    </div>
    <div v-if="projectName == 'xurigo'">
      <mu-dialog :open="dialog" title="温馨提示" @close="close">
          <span v-if = "msg != null">{{msg}}</span> 
          <span v-if = "isLose == 1">您长时间未操作，账号已退出，请重新登录</span> 
          <span v-if = "isLose == 2">您账号已在另外终端进行操作，若想在此终端继续操作，请重新登录操作</span> 
        <mu-flat-button slot="actions" primary @click="close" label="确定"/>
      </mu-dialog>
    </div>
  </div>
  </template>
  <script>
  import md5 from 'js-md5'
  import UserCache from '../util/cache'
  export default {
    data () {
      return {
        username: window.localStorage['XRLoginRememberUserName']?window.localStorage['XRLoginRememberUserName']:'',
        password: '',      
        isShow : 'none',
        dialog: false,
        isLose:0,
		msg:"",
        isRemember: window.localStorage['XRLoginIsRememberUserName']?true:false,
        siteConfig:{ MobileBgImage : '' }
      }
    },
    mounted : function(){
      this.$postBase(
        this.MOBILE_URL + "/Oauth2/WeChat/wechat.ashx"
        ).then(function(res) {
        if(!res.IsSuccess){
            //ths.$refs.XRtoast.failed(res.Msg, true)
        }else{
            wx.config({
                debug: false, // 开启调试模式,调用的所有api的返回值会在客户端alert出来，若要查看传入的参数，可以在pc端打开，参数信息会通过log打出，仅在pc端时才会打印。
                appId: res.Data.AppId, // 必填，公众号的唯一标识
                timestamp: res.Data.TimeStamp, // 必填，生成签名的时间戳
                nonceStr: res.Data.NonceStr, // 必填，生成签名的随机串
                signature: res.Data.Sign, // 必填，签名，见附录1
                jsApiList: [] // 必填，需要使用的JS接口列表，所有JS接口列表见附录2
            });
            wx.ready(function () {
                WeixinJSBridge.call('hideOptionMenu');
            });
        }
      });
      this.isLose = this.$route.query.isLose
	  this.msg = this.$route.query.msg
      if(this.isLose == 1 || this.isLose == 2 || this.msg != null){
        this.dialog = true
      }
      this.getSiteInfo()
    },
    methods: {
      getSiteInfo: function () {
        const ths = this;
        this.$post('/Shop/SiteConfigServer/GetSiteConfig')
            .then(function (res) {
            if(res.IsSuccess){
                ths.siteConfig = res.Data
                console.log(ths.siteConfig)
            }
        })
        .catch(function (err) {
            console.log(err)
        })    
      },
      isWeixinBrowser(ua) {
        return (/micromessenger/.test(ua)) ? true : false;
      },
      open () {
      this.dialog = true
      },
      close () {
        this.dialog = false
      },
      close2(){
        this.dialog = false
        this.$router.goBack()
      },
      Login: function () {
        const ths = this;
        var json = {}
        json.username = this.username
        json.password = md5(this.password)
  
        let ua = navigator.userAgent.toLowerCase()
        if(this.isWeixinBrowser(ua)){        
          json.openid = this.$store.state.wechat.WeChatInfo
          //alert(json.openid)
          //alert("微信浏览器：openid="+ this.registerInfo.WeChat.openid)
        }else{
          //alert("不是微信浏览器")
        }
  
  
        this.$post('/Shop/UserServer/Login', JSON.stringify(json))
          .then(function (res) { 
              if(res.IsSuccess){
                ths.$refs.XRtoast.success(res.Msg)   
                
                if(ths.isRemember){
                  window.localStorage['XRLoginRememberUserName'] = json.username
                }else{
                  window.localStorage.removeItem('XRLoginRememberUserName')
                }
  
                if(!res.Data.HeadPic){
                  res.Data.HeadPic = 'http://frontend.xurigo.com/icon/person.jpg'
                }
                
                ths.$store.dispatch('SetUser', res.Data.SessionId)
                
                var redirect = ths.$route.query.redirect
                if(!redirect){
                  redirect = "/usercenter/index"
                }     
                
                if(!res.Data.isTestPhone){
                  redirect = "/usercenter/mobileBind"
                }
                ths.$router.push(redirect)
              }
              else{
                ths.$refs.XRtoast.failed(res.Msg,true)    
              }  
          })
          .catch(function (err) {
            console.log(err)
          })      
      }
    },
    watch:{
      isRemember(val){      
        if(val){
          window.localStorage['XRLoginIsRememberUserName'] = true
        }else{
          window.localStorage.removeItem('XRLoginIsRememberUserName')
        }
        this.isRemember =val
      }
    }
  }
  
  </script>
  <style>
  #loginPage{  
    background: #eee;
  }
  #loginPage .mu-appbar{
    background: rgba(150,150,150,0.2);
    position: fixed;
    top: 0px;
  }
  #loginPage .loginbg {
    width: 100%;
    display: block;
  }
  #loginPage .login-form {
    padding: 10px 10px 60px;
    position: absolute;
    width: 95%;
    margin: 0 auto;
    left: 0;
    right: 0;
    background: #fff;
    top: 100px;
    border-radius: 10px 10px;
  }
  #loginPage .login-div {
    padding: 40px 10px 0 10px;
  }
  #loginPage .demo-raised-button {
    height: 50px;
    background: #ff4981;
  }
  #loginPage .div2 {
    padding: 20px 0 0 0;
  }
  #loginPage .demo-flat-button.left {
    float: left;
  }
  #loginPage .demo-flat-button.right {
    float: right;
  }
  #loginPage .div3 {
    text-align: center;
    position: absolute;
    bottom: 40px;
    left: 0;
  }
  </style>
  


// WEBPACK FOOTER //
// src/pages/login.vue